import * as React from "react"
import { cn } from "../../lib/utils"

export const Avatar = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)} {...props} />
  )
)
Avatar.displayName = "Avatar"

export const AvatarImage = React.forwardRef<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>(
  ({ className, onError, ...props }, ref) => {
    const [hasError, setHasError] = React.useState(false);
    if (hasError || !props.src) return null;
    return (
      <img
        ref={ref}
        className={cn("object-cover w-full h-full", className)}
        alt=""
        {...props}
        onError={(e) => {
          setHasError(true);
          onError?.(e);
        }}
      />
    );
  }
);
AvatarImage.displayName = "AvatarImage";

export const AvatarFallback = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...props }, ref) => (
    <span ref={ref} className={cn("flex h-full w-full items-center justify-center bg-muted text-muted-foreground", className)} {...props} />
  )
)
AvatarFallback.displayName = "AvatarFallback"; 